import { render, staticRenderFns } from "./FormResolver.vue?vue&type=template&id=37b6593a&scoped=true&"
import script from "./FormResolver.vue?vue&type=script&lang=js&"
export * from "./FormResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6593a",
  null
  
)

export default component.exports